import {CoinsSections_ViewAchievementsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useCoinsLatestAchievementsOpenedState} from '../CoinsLatestAchievements/utils/useCoinsLatestAchievementsOpenedState';
import {CoinsLinkSection} from '../CoinsLinkSection';

export const CoinsViewAchievements: React.FC<
  CoinsSections_ViewAchievementsSection
> = ({title, content}) => {
  const {open} = useCoinsLatestAchievementsOpenedState();

  return (
    <StyledCoinsLinkSection
      onClick={open}
      title={title}
      data-testid="coinsLatestAchievements"
    >
      <TitleWrapper>
        🎉
        <Text weight="mediumBold">{content.title}</Text>
      </TitleWrapper>
      <Text size="px10" weight="mediumBold">
        {content.description}
      </Text>
    </StyledCoinsLinkSection>
  );
};

const StyledCoinsLinkSection = styled(CoinsLinkSection)`
  text-align: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: ${SPACING['Y.Md']};
`;
